import type { ReimagineAssessmentSnapshot } from "../types/axlPilotContext";

let cachedSnapshot: ReimagineAssessmentSnapshot | null = null;

export function setAxlPilotAssessmentSnapshot(
  snapshot: ReimagineAssessmentSnapshot | null
): void {
  cachedSnapshot = snapshot;
}

export function getAxlPilotAssessmentSnapshot(): ReimagineAssessmentSnapshot | null {
  return cachedSnapshot;
}

export function clearAxlPilotAssessmentSnapshot(): void {
  cachedSnapshot = null;
}
